import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=73e4fc3c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=73e4fc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4fc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e4fc3c')) {
      api.createRecord('73e4fc3c', component.options)
    } else {
      api.reload('73e4fc3c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=73e4fc3c&scoped=true&", function () {
      api.rerender('73e4fc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oTD4RQ9Q1UWQ/JS/comp/DocBox.vue"
export default component.exports